export default "__VITE_ASSET__BbOXBmtB__"